import { KeycloakAdminService } from '@nv/auth'
import AdminAxiosInstance from './AdminAxiosInstance'
import { AdminReportsService } from './AdminReports'

const axiosInstance = AdminAxiosInstance

export const AdminVoterService = {
  ...AdminReportsService,
  getUserInfoKeycloakToken: () => {
    try {
      const parsedToken = KeycloakAdminService.getParsedToken()
      let user = {}
      if (parsedToken) {
        user = {
          username: parsedToken.preferred_username,
          email: parsedToken.email,
          phone: parsedToken.phone_number,
          phoneNumber: parsedToken.phone_number,
        }
      }
      return user
    } catch (error) {
      /* empty */
    }
  },
  syncEvents: async () => {
    try {
      const events = await axiosInstance.get('/events/v2/sync')
      return { events }
    } catch (error) {
      /* empty */
    }
  },
  syncCalendarEvents: async () => {
    try {
      const events = await axiosInstance.get('/events/sync')
      return { events }
    } catch (error) {
      /* empty */
    }
  },
  updateEvent: async (eventId, votingDistrict, votingChannel) => {
    try {
      const event = await axiosInstance.put(`/events/${eventId}`, {
        votingDistrict: votingDistrict,
        votingChannel: votingChannel,
      })
      return { event, success: true }
    } catch (error) {
      //console.log(error)
    }
  },
  getVoterCount: async () => {
    const count = await axiosInstance.get('/count-users-db')
    try {
      return count
    } catch (error) {
      //console.error(count)
    }
  },
  getEligibleVoterCount: async () => {
    const count = await axiosInstance.get('/count-eligible-users-db')
    try {
      return count
    } catch (error) {
      //console.error(count)
    }
  },
  uploadVoterList: async (voterlist) => {
    try {
      const resp = await axiosInstance.post('/voters', voterlist)
      //console.log(resp)
      return { success: true, ...resp }
    } catch (error: any) {
      if (error?.response?.data) {
        //console.error(error.response.data)
        const errorDisplay = error.response.data
        if (errorDisplay.error?.code === 500) {
          return {
            error: {
              ...errorDisplay,
              message: 'Something went wrong, please contact support',
            },
          }
        }
        return errorDisplay
      } else {
        //console.error(error)
        return {
          error: {
            code: 500,
            message: 'Something went wrong, please contact support',
          },
        }
      }
    }
  },
  uploadEligibleVoterList: async (voterlist) => {
    try {
      const resp = await axiosInstance.post('/eligiblevoters', voterlist)
      //console.log(resp)
      return { success: true, ...resp }
    } catch (error: any) {
      if (error?.response?.data) {
        //console.error(error.response.data)
        const errorDisplay = error.response.data
        if (errorDisplay.error?.code === 500) {
          return {
            error: {
              ...errorDisplay,
              message: 'Something went wrong, please contact support',
            },
          }
        }
        return errorDisplay
      } else {
        //console.error(error)
        return {
          error: {
            code: 500,
            message: 'Something went wrong, please contact support',
          },
        }
      }
    }
  },
  uploadStrikeOffVoterList: async (voterlist) => {
    try {
      const resp = await axiosInstance.post('/eligiblevoters/strikeoff', voterlist)
      //console.log(resp)
      return { success: true, ...resp }
    } catch (error: any) {
      if (error?.response?.data) {
        //console.error(error.response.data)
        const errorDisplay = error.response.data
        if (errorDisplay.error?.code === 500) {
          return {
            error: {
              ...errorDisplay,
              message: 'Something went wrong, please contact support',
            },
          }
        }
        return errorDisplay
      } else {
        //console.error(error)
        return {
          error: {
            code: 500,
            message: 'Something went wrong, please contact support',
          },
        }
      }
    }
  },
  removeIneligibleVoters: async (voterlist) => {
    try {
      const resp = await axiosInstance.post('/eligiblevoters/delete', voterlist)
      //console.log(resp)
      return { success: true, ...resp }
    } catch (error: any) {
      if (error?.response?.data) {
        //console.error(error.response.data)
        const errorDisplay = error.response.data
        if (errorDisplay.error?.code === 500) {
          return {
            error: {
              ...errorDisplay,
              message: 'Something went wrong, please contact support',
            },
          }
        }
        return errorDisplay
      } else {
        //console.error(error)
        return {
          error: {
            code: 500,
            message: 'Something went wrong, please contact support',
          },
        }
      }
    }
  },
  fetchVoters: async (
    districtFilter = 'all',
    channelFilter = 'all',
    limit = 1000,
    skip = 0,
    search = '',
    status = 'All',
    sort = '',
    voteByMailStatus = 'all',
    voteByMailAddress = 'all',
  ) => {
    try {
      const res: any = await axiosInstance.get(
        `/users?votingDistrict=${districtFilter}&votingChannel=${channelFilter}&limit=${limit}&skip=${skip}&search=${search}&status=${status}&sort=${sort}&voteByMailStatus=${voteByMailStatus}&voteByMailAddress=${voteByMailAddress}`,
      )
      return { success: true, users: res.users, numUsers: res.numUsers }
    } catch (error) {
      // console.log(error)
    }
  },
  fetchVotersPipsc: async (filters = null, channelFilter = 'online', limit = 1000, skip = 0, search = '') => {
    try {
      let url = `/users?votingChannel=${channelFilter}&limit=${limit}&skip=${skip}&search=${search}`
      const keys = Object.keys(filters)
      for (var key of keys) {
        const filter = filters[key]
        if (filter) {
          let fitlerString = ''
          if (Array.isArray(filter)) {
            const values = filter.map((f) => f.accountId)
            fitlerString = `&${key}=${values.toString()}`
          } else {
            fitlerString = `&${key}=${filter.accountId}`
          }
          url += fitlerString
        }
      }
      //console.log(url)
      const res: any = await axiosInstance.get(url)
      //console.log(res)
      return { success: true, users: res.users, numUsers: res.numUsers }
    } catch (error) {
      //console.log(error)
    }
  },
  fetchEligibleVoters: async (
    districtFilter = 'all',
    channelFilter = 'all',
    limit = 1000,
    skip = 0,
    search = '',
    status = 'all',
    voteByMailStatus = 'all',
    voteByMailAddress = 'all',
  ) => {
    try {
      let url = `/eligiblevoters?votingDistrict=${districtFilter}&votingChannel=${channelFilter}&limit=${limit}&skip=${skip}&status=${status}&voteByMailStatus=${voteByMailStatus}&voteByMailAddress=${voteByMailAddress}`
      if (typeof search === 'string') {
        url += `&search=${search}`
      } else if (Object.keys(search)?.length) {
        for (var key of Object.keys(search)) {
          url += `&search.${key}=${search[key]}`
        }
      }
      const res: any = await axiosInstance.get(url)
      // console.log(res)
      return { success: true, users: res.users, numUsers: res.numUsers }
    } catch (error) {
      //console.log(error)
    }
  },
  fetchEligibleVotersCsv: async (districtFilter = 'all', channelFilter = 'all') => {
    try {
      const result = await axiosInstance.get(`/eligiblevoters/csv?votingDistrict=${districtFilter}&votingChannel=${channelFilter}`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },
  getVoterCsv: async (districtFilter = 'all', channelFilter = 'all') => {
    try {
      const result = await axiosInstance.get(`/users/csv?votingDistrict=${districtFilter}&votingChannel=${channelFilter}`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.log(error)
    }
  },

  getVoterCsvPipsc: async (filters = null, channelFilter = 'online', locale = 'en') => {
    try {
      let url = `/users/csv?votingChannel=${channelFilter}&locale=${locale}`
      const keys = Object.keys(filters)
      for (var key of keys) {
        const filter = filters[key]
        if (filter) {
          let fitlerString = ''
          if (Array.isArray(filter)) {
            const values = filter.map((f) => f.accountId)
            fitlerString = `&${key}=${values.toString()}`
          } else {
            fitlerString = `&${key}=${filter.accountId}`
          }
          url += fitlerString
        }
      }
      //console.log(url)
      const result = await axiosInstance.get(url, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      //console.log(error)
    }
  },
  getEventVoterList: async (tiviId, limit = 1000, skip = 0, search = '') => {
    try {
      const res: any = await axiosInstance.get(`/events/${tiviId}/voters?limit=${limit}&skip=${skip}&search=${search}`)
      return { users: res.users, numUsers: res.numUsers }
    } catch (error) {
      //console.error(error)
      //return {error}
    }
  },
  getEventVoterListCSV: async (tiviId, locale = 'en') => {
    try {
      const result = await axiosInstance.get(`/events/${tiviId}/voters/csv?locale=${locale}`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      //console.error(error)
      //return {error}
    }
  },
  getEvent: async (eventId) => {
    try {
      const result = await axiosInstance.get(`/events/${eventId}`)
      return { event: result }
    } catch (error) {
      //console.error(error)
      //return {error}
    }
  },
  getOnlineEventsList: async (district) => {
    try {
      const events = await axiosInstance.get(`/events/online?votingDistrict=${district}`)
      return events
    } catch (error) {
      //console.error(error)
      // return {error}
    }
  },
  sendEmailsOnlineVoters: async (tiviId) => {
    try {
      if (tiviId) {
        await axiosInstance.post(`/events/${tiviId}/email/voters`)
      } else {
        await axiosInstance.post(`/email/voters`)
      }
      return { success: true }
    } catch (error) {
      //console.error(error)
      // return {error}
    }
  },
  getVoteReceiptReport: async (tiviId, language) => {
    try {
      const data = await axiosInstance.get(`/votereceiptreport/${tiviId}?language=${language}`, {
        responseType: 'blob',
      })
      return { success: true, data }
    } catch (error) {
      //console.error(error)
      // return {error}
    }
  },
  getAuthLogReport: async (formData, language) => {
    try {
      let url = `/authlogs/${formData.userType}?language=${language}`

      let startDate = ''
      let endDate = ''
      if (formData.startDate && formData.endDate) {
        startDate = formData.startDate.toISOString()
        endDate = formData.endDate.toISOString()
        url = `${url}&startDate=${startDate}&endDate=${endDate}`
      }
      const data = await axiosInstance.get(url, {
        responseType: 'blob',
      })
      return { success: true, data }
    } catch (error) {
      //console.error(error)
      // return {error}
    }
  },
  updateUserLanguage: async (language) => {
    try {
      await axiosInstance.put('/account/language', { language: language })
    } catch (error) {
      /* empty */
    }
  },
  // updateType is enum : ['edit, 'update']
  // voterId is user.voterId
  // tiviId is event.tiviId
  updateVoter: async ({ voterId, email = '', phone = '', updateType }) => {
    try {
      await axiosInstance.post(`/users/${voterId}/update/${updateType}`, {
        email,
        phone,
      })
      return { success: true }
    } catch (error) {
      return { success: false }
    }
  },
  resetVoterPassword: async ({ keycloakId }) => {
    try {
      await axiosInstance.post(`/users/${keycloakId}/resetpassword`)
      return { success: true }
    } catch (error) {
      return { success: false }
    }
  },
  getParentFilters: async (accountType, language) => {
    try {
      //console.log('accountType', accountType)

      const response: any = await axiosInstance.get(`/pipsc/accounts?accountType=${accountType}&locale=${language}`)
      const listOptions = response.map((r) => {
        return {
          ...r,
          label: r.title?.en ? r.title[language] : r.abbreviation[language],
          value: r.accountId,
        }
      })
      return listOptions
    } catch (error) {
      //console.log(error)
    }
  },
  getChildFilters: async (parentId, language) => {
    try {
      //console.log('parentId', parentId)
      const response: any = await axiosInstance.get(`/pipsc/accounts?parentId=${parentId}&locale=${language}`)
      const listOptions = response.map((r) => {
        return {
          ...r,
          label: r.title?.en ? r.title[language] : r.abbreviation[language],
          value: r.accountId,
        }
      })
      return listOptions
    } catch (error) {
      //console.log(error)
    }
  },
  approveVoter: async (id, electorId) => {
    try {
      await axiosInstance.put(`/voters/${id}/approve/${electorId}`)
      return { success: true }
    } catch (error) {
      return { error }
    }
  },
  updateRegistration: async (id, data) => {
    try {
      await axiosInstance.put(`/voters/${id}/update`, data)
      return { success: true }
    } catch (error) {
      return { error }
    }
  },
  getDeclineOptions: async (currentLanguage) => {
    try {
      const reasons = await axiosInstance.get(`/voters/declineReasons`)
      const reasonOptions = []
      for (var key in reasons) {
        reasonOptions.push({
          value: key,
          label: reasons[key][currentLanguage],
        })
      }
      return reasonOptions
    } catch (error) {
      return []
    }
  },
  declineVoter: async (id, reason) => {
    try {
      await axiosInstance.put(`/voters/${id}/decline`, reason)
      return { success: true }
    } catch (error) {
      return { success: false }
    }
  },
  markAsPendingWithIssue: async (id) => {
    try {
      await axiosInstance.put(`/voters/${id}/pending-with-issue`)
      return { success: true }
    } catch (error) {
      return { success: false }
    }
  },
  disableVoter: async (electorId) => {
    try {
      const response = await axiosInstance.put(`/eligiblevoters/${electorId}/disable`)

      return response
    } catch (error) {
      //console.log(error)
    }
  },
  getFilterByGroup: async (accountType) => {
    try {
      const response = await axiosInstance.get(`/pipsc/accounts?accountType=${accountType}`)

      return response
    } catch (error) {
      //console.log(error)
    }
  },
  getSubGroupOptions: async ({ parentId }) => {
    try {
      const response = await axiosInstance.get(`/pipsc/accounts?parentId=${parentId}`)

      return response
    } catch (error) {
      //console.log(error)
    }
  },
  registerVoter: async (data) => {
    try {
      const result = await axiosInstance.post(`/voters/registration/`, data)
      return { success: true, data: result.data }
    } catch (error) {
      // console.log(error)
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  getEligible: async (id) => {
    try {
      const result = await axiosInstance.get(`/eligiblevoters/${id}`)
      return { result }
    } catch (error) {
      return { error }
    }
  },
  updateEligible: async (id, data) => {
    try {
      await axiosInstance.put(`/eligiblevoters/${id}/update`, data)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  removeEligible: async (id, data) => {
    try {
      await axiosInstance.put(`/eligiblevoters/${id}/remove`, data)

      return { success: true }
    } catch (error) {
      return { error }
    }
  },
  strikeOffEligible: async (electorId, data) => {
    try {
      await axiosInstance.put(`/eligiblevoters/${electorId}/strike-off`, data)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  reverseStrikeOffEligible: async (electorId, data) => {
    try {
      await axiosInstance.put(`/eligiblevoters/${electorId}/reverse-strike-off`, data)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  fetchEventConfigJurisdictionsBySchoolBoard: async (schoolboard) => {
    try {
      const result = await axiosInstance.get(`/events/config/${schoolboard}/jurisdictions/csv/`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.error(error)
    }
  },
  fetchEventConfigVotersBySchoolBoard: async (schoolboard) => {
    try {
      const result = await axiosInstance.get(`/events/config/${schoolboard}/voters/csv/`, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.error(error)
    }
  },
  updateVoteByMailBallotStatus: async (electorId, data) => {
    try {
      await axiosInstance.put(`/eligiblevoters/${electorId}/mailStatus`, data)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  revertVoteByMailBallotStatus: async (electorId) => {
    try {
      await axiosInstance.put(`/eligiblevoters/${electorId}/revertMailStatus`)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  updateVoteByMailBallotStatusBulk: async (electorIds, mailBallotStatus) => {
    try {
      const resp = await axiosInstance.put(`/eligiblevoters/bulk/mailStatus`, { electorIds, mailBallotStatus })
      //@ts-ignore
      return { successUpdateIds: resp.successUpdateIds, errorUpdateIds: resp.errorUpdateIds, success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  getVoteByMailPackageVoter: async (id) => {
    try {
      const url = `/eligiblevoters/${id}/vbm-package`

      const result: any = await axiosInstance.get(url, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      /* empty */
    }
  },
  getVoteByMailPackageVoterBulk: async (eligibleIds) => {
    try {
      const result = await axiosInstance.post(
        `/eligiblevoters/bulk/vbm-package`,
        { eligibleIds },
        {
          responseType: 'blob',
        },
      )
      return { success: true, data: result }
    } catch (error) {
      console.error(error)
    }
  },
  updateNotes: async (electorId, data) => {
    try {
      await axiosInstance.put(`/eligiblevoters/${electorId}/notes`, data)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  updateNotesRegistration: async (voterId, data) => {
    try {
      await axiosInstance.put(`/voters/${voterId}/notes`, data)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  updateIdentificationRegistration: async (voterId, data) => {
    try {
      await axiosInstance.put(`/voters/${voterId}/identification`, data)
      return { success: true }
    } catch (error) {
      //@ts-ignore
      return { error: error.response?.data?.error }
    }
  },
  getVoteByMailStats: async () => {
    try {
      const url = `/stats/vbm`

      const result: any = await axiosInstance.get(url, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.error(error)
    }
  },
  getVbmBallotStats: async () => {
    try {
      const url = `/reports/vbm-report-ballots-by-wards`

      const result: any = await axiosInstance.get(url, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.error(error)
    }
  },
  getVoteByMailDailyStats: async () => {
    try {
      const url = `/stats/vbm/daily`

      const result: any = await axiosInstance.get(url, {
        responseType: 'blob',
      })
      return { success: true, data: result }
    } catch (error) {
      console.error(error)
    }
  },
}
